<!-- 详情 -->
<template>
<div class="m-topic-details">
    <div class="nav">
        <van-icon name="arrow-left" @click="handleClose" />
        <div class="nav-name">每日一练</div>
    </div>
    <div class="details-content">
        <el-scrollbar class="content-scroll">
            <img :src="subjectinfo.banner" class="banner" />
			<div class="text-info">
				<div class="title">{{subjectinfo.showLabel}}</div>
				<div class="uprice">￥{{subjectinfo.uprice}}</div>
				<div class="info-item">
					<div class="label">适用人群：</div>
					<div class="info-box">
						<div class="info">有一定自律学习意识，希望考前系统备考的考生</div>
					</div>
				</div>
				<div class="info-item">
					<div class="label">题库特色：</div>
					<div class="info-box">
						<div class="info">章节习题练习</div>
						<div class="info">历年真题详解</div>
						<div class="info">错题自动记录</div>
						<div class="info">在线模拟试题</div>
					</div>
				</div>
				<div class="info-item">
					<div class="label">有 效 期：</div>
					<div class="info-box">
						<div class="info">购买后12个月</div>
					</div>
				</div>
			</div>
			<div class="details-box">
				<img :src="require('@/common/images/mSpecialTopic/details/jjcy_1.jpg')" class="details-img" v-if="subjectinfo.examcode === 'jjcy'" style="height: 5.61rem" />
				<img :src="require('@/common/images/mSpecialTopic/details/zqcy_1.jpg')" class="details-img" v-if="subjectinfo.examcode === 'zqcy'" style="height: 5.61rem" />
				<img :src="require('@/common/images/mSpecialTopic/details/qhcy_1.jpg')" class="details-img" v-if="subjectinfo.examcode === 'qhcy'" style="height: 5.61rem" />
				<img :src="require('@/common/images/mSpecialTopic/details/details_2.jpg')" class="details-img" style="height: 7.27rem" />
				<img :src="require('@/common/images/mSpecialTopic/details/details_3.jpg')" class="details-img" style="height: 6.36rem" />
				<img :src="require('@/common/images/mSpecialTopic/details/details_4.jpg')" class="details-img" style="height: 10.72rem" />
				<img :src="require('@/common/images/mSpecialTopic/details/details_5.jpg')" class="details-img" style="height: 7.67rem" />
				<img :src="require('@/common/images/mSpecialTopic/details/details_6.jpg')" class="details-img" style="height: 14.4rem" />
			</div>
        </el-scrollbar>
        <div class="btn-box">
			<div class="btn" @click="handleBuy">立即购买</div>
		</div>
    </div>
    <BuyPopup ref="buyPopup"></BuyPopup>
</div>
</template>

<script>
import {mapGetters} from 'vuex'
import BuyPopup from './page/component/buyPopup.vue'
export default {
    data() {
        return {
            subjectinfo: {}
        }
    },
    components: {
        BuyPopup
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if (localStorage.getItem('topicItem')) {
            this.subjectinfo = JSON.parse(localStorage.getItem('topicItem'))
        } else {
            location.replace = location.origin + '/m/specialTopic/jjcy/choose'
        }
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleClose() {
            this.$router.go(-1)
        },
        handleBuy() {
            if (this.user.loginToken) {
                this.$refs.buyPopup.handleOpen(this.subjectinfo.examcode, this.subjectinfo.subjectcode)
            } else {
                this.$router.push({
                    name: 'MLogin'
                })
            }
        }
    },
    computed: {
        ...mapGetters(
            ['user']
        )
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.m-topic-details {
    height: 100vh;
    width: 100vw;
    .nav {
        background: #fff;
        height: 0.88rem;
        padding: 0 0.32rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 10;
        box-shadow: 0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
        .van-icon {
            font-size: 0.4rem;
            position: relative;
            z-index: 12;
        }
        .nav-name {
            position: absolute;
            z-index: 11;
            width: 100%;
            left: 0;
            line-height: 0.88rem;
            text-align: center;
            font-size: 0.34rem;
            color: #333333;
            font-weight: bold;
            box-sizing: border-box;
        }
    }
    .details-content {
        height: calc(100% - 0.88rem);
        .content-scroll {
            height: calc(100% - 1rem);
            background: #F8F8F8;
            .banner {
				width: 100%;
				height: 4.2rem;
				vertical-align: middle;
			}
			.text-info {
				padding: 0.32rem;
				box-sizing: border-box;
				background: #fff;
				margin-bottom: 0.2rem;
				.title {
					font-size: 0.32rem;
					color: #333333;
					line-height: 0.45rem;
					margin-bottom: 0.2rem;
					font-weight: bold;
				}
				.uprice {
					font-size: 0.36rem;
					color: #FA2B19;
					font-weight: bold;
					margin-bottom: 0.24rem;
				}
				.info-item {
					display: flex;
					.label {
						font-size: 0.28rem;
						color: #999999;
						line-height: 0.48rem;
						height: 0.48rem;
						width: 1.4rem;
					}
					.info-box {
						display: flex;
						flex-wrap: wrap;
						flex: 1;
						width: 0;
						.info {
							background: rgba(255,153,80,0.1);
							padding: 0 0.1rem;
							color: #DE772E;
							font-size: 0.24rem;
							line-height: 0.48rem;
							margin-bottom: 0.14rem;
							margin-right: 0.12rem;
						}
					}
				}
			}
			.details-box {
				.details-img {
					width: 100%;
                    height: auto;
					vertical-align: middle;
				}
			}
        }
        .btn-box {
			height: 1rem;
			background: #fff;
			padding: 0 0.24rem;
			display: flex;
			align-items: center;
			.btn {
				width: 100%;
				height: 0.88rem;
				background: linear-gradient( 180deg, #FFBD59 0%, #ED854A 100%);
				border-radius: 1rem;
				color: #fff;
				font-size: 0.32rem;
				text-align: center;
				line-height: 0.88rem;
			}
		}
    }
}
</style>